import { Injectable, Signal, inject, signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { BreakpointObserver } from '@angular/cdk/layout';
import { map } from 'rxjs';
import { layoutWindowBreakpoints } from '../../consts/layout-window-breakpoints';

const mobileMediaQuery = `(max-width: ${layoutWindowBreakpoints.sm - 1}px)`;

@Injectable({ providedIn: 'root' })
export class OverlayDialogService {
    private readonly breakpointObserver = inject(BreakpointObserver);
    private readonly openState = signal(false);
    public readonly isOverlayOpen: Signal<boolean> = this.openState.asReadonly();
    public readonly isMobile: Signal<boolean> = toSignal(
        this.breakpointObserver.observe(mobileMediaQuery).pipe(map(state => state.matches)),
        {
            initialValue: this.breakpointObserver.isMatched(mobileMediaQuery)
        }
    );

    public open(): void {
        this.openState.set(true);
    }

    public close(): void {
        this.openState.set(false);
    }
}
